"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { ErrorInfo, ReactNode } from "react"
import { Box, Typography, Button } from "@mui/material"
import * as Sentry from "@sentry/nextjs"

type Props = {
  children: ReactNode
  onReset?: () => void
}

type State = {
  hasError: boolean
  error: Error | null
}

class HIPAAtizerErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setTag("component", "HIPAAtizerEmbed")
      scope.setTag("error_type", "iframe_communication")
      scope.setContext("errorInfo", errorInfo as unknown as Record<string, unknown>)
      scope.setContext("componentStack", {
        stack: errorInfo.componentStack,
      })

      if (typeof window !== "undefined") {
        scope.setContext("browser", {
          userAgent: window.navigator.userAgent,
          isMobile: /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent),
          isSafari: /^((?!chrome|android).)*safari/i.test(
            window.navigator.userAgent,
          ),
        })
      }

      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            color: "#d32f2f",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Unable to load secure form
          </Typography>
          <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
            There was an issue loading the form. Please try closing and reopening
            this dialog, or contact support if the problem persists.
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              this.setState({ hasError: false, error: null })
              if (this.props.onReset) {
                this.props.onReset()
              }
            }}
          >
            Try Again
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

export default HIPAAtizerErrorBoundary
